import calculateImageProxyPath from './calculateImageProxyPath';
import { DatapointStatus } from 'owa-analytics';
import loadImageFromSrc from './loadImageFromSrc';
import createImageProxyDatapoint, {
    ImageProxyEndpoint,
    ImageProxyTelemetryConfig,
} from './createImageProxyDatapoint';

// We want to capture perf for both model B and D for latency comparision

/**
 * Load an image from model B proxy -- connector proxy
 * @param img The image
 */
export default async function loadFromModelBProxy(
    img: HTMLImageElement,
    telemetryConfig: ImageProxyTelemetryConfig
): Promise<boolean> {
    const modelBDatapoint = createImageProxyDatapoint(
        {
            endpoint: ImageProxyEndpoint.ModelB,
        },
        telemetryConfig
    );
    const modelBProxySrc = await calculateImageProxyPath(img);
    if (modelBProxySrc) {
        if (await loadImageFromSrc(img, modelBProxySrc)) {
            modelBDatapoint.endWithSuccess();
            return true;
        } else {
            modelBDatapoint.endWithError(DatapointStatus.ServerError);
        }
    } else {
        modelBDatapoint.endWithError(DatapointStatus.ClientError);
    }

    return false;
}
